import React, { useState, useEffect, Fragment } from "react";
import { Link } from 'react-router-dom';
import CardMembers from "./card_news";
import Loader from '../common/loaderapp';

const Formquestion = () => {
    const [formquestion, setFormquestion] = useState([])
    const [actualizar, setActualizar] = useState(false)
    const [load, setLoad] = useState(true)

    useEffect(() => {
        fetch('/p_contact_form', {headers: {'Content-Type': 'application/json'}})
        .then(res => res.json())
        .then(res => {
            console.log(res);
            setFormquestion(res)
            setActualizar(false)
            setLoad(false)
        })
        .catch(err => console.log('Error:',err))
    }, [actualizar]);

    return (
        <Fragment>
            {load ? 
            <Loader/>: 
            <Fragment>
                <div className="col-sm-12 mt-5 mb-5">
                    <div className="row">
                        <div className="col-sm-12 mb-2 mt-3"></div>
                    </div>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <h5>Questions</h5>
                            <p>You can edit the name, photo and title, also you can add questions or delete them.</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12"> 
                            <div className="card mt-2">
                                <div className="table-responsive prueba">
                                    <table className="table table-sticky v2">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                   First name
                                                </th>
                                                <th scope="col">
                                                    Last name
                                                </th>
                                                <th scope="col">
                                                    Phone
                                                </th>
                                                <th scope="col">
                                                    Email
                                                </th>
                                                <th scope="col">
                                                    Preview
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            { formquestion.map(x=>
                                                <tr> 
                                                    <td>
                                                        {x.NAME_HAQ}
                                                    </td>
                                                    <td>
                                                        {x.LAST_NAME_HAQ}
                                                    </td>
                                                    <td>
                                                        {x.PHONE_NUMBER_HAQ}
                                                    </td>
                                                    <td>
                                                        {x.EMAIL_HAQ}
                                                    </td>
                                                    <td>
                                                        <Link to={"/formquestion-edit/"+x.ID_HAQ}>
                                                            <button className="btnAddSpeaker btnOrange">View</button>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            ) }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment >
            }
        </Fragment>
    );
}
export default Formquestion;